import ModuleReviewFooter from 'shared/components/molecules/ModuleReviewFooter/ModuleReviewFooter';

export default ModuleReviewFooter;
